import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const defaultToggleButtonRenderer = ({ isOverflowing, isCollapsed, toggleCollapseState }) => (
  isOverflowing
    ? (
      <button onClick={toggleCollapseState} className="defaultToggleButton link-button" tabIndex="0">
        {isCollapsed ? ' more' : ' less'}
      </button>
    )
    : null
);

defaultToggleButtonRenderer.propTypes = {
  isOverflowing: PropTypes.bool.isRequired,
  isCollapsed: PropTypes.bool.isRequired,
  toggleCollapseState: PropTypes.func.isRequired,
};

class CollapsibleWrapper extends PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
    isInitiallyCollapsed: PropTypes.bool,
    toggleButtonRenderer: PropTypes.func,
    className: PropTypes.string,
  };

  static defaultProps = {
    isInitiallyCollapsed: true,
    toggleButtonRenderer: defaultToggleButtonRenderer,
  };

  state = {
    isCollapsed: this.props.isInitiallyCollapsed,
    recalculateFlag: false,
    isOverflowing: false,
  };

  componentDidMount = () => {
    window.addEventListener('resize', this.windowResizeHandler);
  };

  componentDidUpdate = prevProps => {
    if (this.props.children !== prevProps.children) {
      this.setState({ recalculateFlag: true });
    }
    if (this.state.recalculateFlag) {
      const innerWrapperWidth = this.innerWrapperRef.getBoundingClientRect().width;
      const wrapperWidth = this.wrapperRef.getBoundingClientRect().width;
      this.setState({
        isOverflowing: innerWrapperWidth > wrapperWidth,
      });
      this.setState({ recalculateFlag: false });
    }
  };

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.windowResizeHandler);
  };

  wrapperRef = null;
  innerWrapperRef = null;

  setWrapperRef = ref => this.wrapperRef = ref;
  setInnerWrapperRef = ref => this.innerWrapperRef = ref;

  windowResizeHandler = () => {
    this.setState({ recalculateFlag: true });
  };

  toggleCollapseState = () => {
    const { isCollapsed } = this.state;
    this.setState({ isCollapsed: !isCollapsed });
  };

  render() {
    const {
      children,
      toggleButtonRenderer,
      className,
    } = this.props;

    const { isCollapsed, recalculateFlag, isOverflowing } = this.state;

    const wrapperClassName = classnames('collapsible-wrapper', className, {
      collapsed: !recalculateFlag && isCollapsed,
      expanded: !recalculateFlag && !isCollapsed,
    });

    return (
      <div className={wrapperClassName} ref={this.setWrapperRef}>
        <span ref={this.setInnerWrapperRef}>{ children }</span>
        { toggleButtonRenderer({ isOverflowing, isCollapsed, toggleCollapseState: this.toggleCollapseState }) }
      </div>
    );
  }
}

export default CollapsibleWrapper;
